import { arraytoObj, cleanEmpty } from "../../helper/sb-fixer";
import { ComponentNames } from "../../constant";
import { ComponentTypeReportingDefaults } from "../../../src/utils/analyticsmapper";
import ReportingService from "../../../src/services/ReportingService";
import { logAdapterEvent, logError } from "../../helper/logger";
import { ReportingDefaults } from "../../../src/services/ReportingDefaults";

const ADAPTER_NAME = "genrePreviewToolAdapater";

interface IGenrePreviewToolAdapter {
  componentProps: any;
  index: number;
  genreSvodOffers: any;
  svodGenreData: any;
  packageConfig: any;
  cmsPageName?: string;
}

export const genrePreviewToolAdapater = ({
  componentProps,
  index,
  genreSvodOffers,
  svodGenreData,
  packageConfig,
  cmsPageName
}: IGenrePreviewToolAdapter): any => {
  try {
    logAdapterEvent(ADAPTER_NAME, "Adapter execution started", {
      index,
      cmsPageName
    });

    const content = cleanEmpty(arraytoObj(componentProps));
    const type = ComponentNames[content.type];
    const data = new ReportingService().fixAnalyticsValues(
      content,
      ReportingDefaults[ComponentTypeReportingDefaults?.[type]],
      type,
      index,
      null,
      "STORYBLOK"
    );
    const svodMapping = genreSvodOffers?.svodMapping || [];
    const offerPrices = genreSvodOffers?.offerPrices || [];

    // Add package data to packages and miniPacks
    content?.packages?.map(pkg => {
      const match = packageConfig?.find(item => item.id === pkg.packageKey);
      if (match) {
        pkg.name = match?.richTextDisplayLabel || match?.displayLabel || "";
        pkg.channelCount = content?.showGPChannelCount ?
          `${(match?.channel?.displayCount || "") +
              (match?.channel?.signLetter || "")
              } ${
              match?.channel?.label || ""}` :
          "";
      }
      return pkg;
    });
    content?.miniPacks?.packs?.map(pkg => {
      const match = packageConfig?.find(item => item.id === pkg.packageKey);
      if (match) {
        pkg.name = match?.richTextDisplayLabel || match?.displayLabel || "";
        pkg.channelCount = content?.showMiniGPChannelCount ?
          `${(match?.channel?.displayCount || "") +
              (match?.channel?.signLetter || "")
              } ${
              match?.channel?.label || ""}` :
          "";
      }
      return pkg;
    });

    // add svod mapping into packages
    content?.packages?.forEach((genrePack, index) => {
      // filter all SVOD's for specific package
      content.packages[index].filteredSvodsData =
        svodGenreData?.filter(svodPackage => svodMapping[genrePack?.packageKey]?.includes(svodPackage?.productSKU)) || [];
      content.packages[index].filteredSvodsData.push(
        ...(content?.packages?.[index]?.comingSoonSvods || [])
      );
      // add dynamic genre base price
      content.packages[index].packagePrice = `$${
        offerPrices?.find?.(
          genre => Object?.keys?.(genre)?.[0] === genrePack?.packageKey
        )?.[`${genrePack?.packageKey}`]?.price
      }/mo.*`;
    });
    // add dynamic genre mini price
    content?.miniPacks?.packs?.forEach?.((miniPack: any, index: number) => {
      content.miniPacks.packs[index].packagePrice = `$${
        offerPrices?.find?.(
          genre => Object?.keys?.(genre)?.[0] === miniPack?.packageKey
        )?.[`${miniPack?.packageKey}`]?.price
      }/mo.*`;
    });

    return {
      props: {
        ...content,
        offerPrices,
        svodMapping,
        svodGenreData,
        analytics: data.analytics,
        options: {
          id: content.id,
          ...content.options
        }
      },
      type: ComponentNames[content.type]
    };
  } catch (error) {
    logError(ADAPTER_NAME, error as Error, {
      index,
      cmsPageName
    });
  }
};

export default genrePreviewToolAdapater;
